import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, TitleStrategy, withInMemoryScrolling } from '@angular/router';
import { AppTitleStrategy } from './core/app-title.strategy';
import { routes } from './app.routes';
import { provideAppConfig } from './core/config/providers';
import { provideCoreHttp } from './core/http/provide-http';
import { entraAuthInterceptor } from './core/http/entra-auth.interceptor';
import { provideAuth } from './core/auth/provide-auth';
import { runtimeConfig } from './core/config/runtime-config';
import { AppConfig } from './core/config/app-config.token';
import { NAV_SECTIONS } from './shared/nav/nav-sections.token';
import { APP_NAV_SECTIONS } from './shared/nav/nav-sections.config';

async function loadRuntimeConfig(): Promise<void> {
  try {
    const res = await fetch('/config.json');
    if (!res.ok) return;
    const json: Partial<AppConfig> = await res.json();
    const { panelDesarrolloLocalVisible: _panelDesarrolloLocalVisible, ...safeRuntimeJson } = json;
    Object.assign(runtimeConfig, safeRuntimeJson);
  } catch {
    // config.json ausente o red caída — se usan los valores compilados
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_INITIALIZER, useFactory: () => loadRuntimeConfig, multi: true },
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    ...provideAppConfig(),
    ...provideAuth(),
    ...provideCoreHttp(() => runtimeConfig.apiBaseUrl, [entraAuthInterceptor]),
    { provide: TitleStrategy, useClass: AppTitleStrategy },

    ...APP_NAV_SECTIONS.map((section) => ({
      provide: NAV_SECTIONS,
      useValue: section,
      multi: true,
    })),
  ],
};
